import { render, staticRenderFns } from "./CampaignMetrics.vue?vue&type=template&id=56766ebf&scoped=true"
import script from "./CampaignMetrics.vue?vue&type=script&lang=js"
export * from "./CampaignMetrics.vue?vue&type=script&lang=js"
import style0 from "./CampaignMetrics.vue?vue&type=style&index=0&id=56766ebf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56766ebf",
  null
  
)

export default component.exports